import template from './retailer-reports-filter.html';

const mapStateToThis = ({ session, dictionaries, dictionary }) => {
  const { locale, isAdmin } = session;
  const { reportCategories } = dictionary;
  const { reportNames } = dictionaries;

  return {
    locale,
    isAdmin,
    reportCategories,
    reportNames,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class RetailerReportsFilterController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.filterReportNames = (reportCategoryId, locale, reportCategories) => (item) => {
      if (reportCategoryId) {
        const reportCategory = reportCategories[parseInt(reportCategoryId, 10)];
        return item.fileTypeTranslationsDto[locale].fileCategoryCd === reportCategory;
      }
      return true;
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onCategoryChange() {
    this.filters.reportName = undefined;
  }

  onInputChange() {
    this.errors = this.form.$error;
  }
}

export default class RetailerReportsFilterComponent {
  constructor() {
    this.template = template;
    this.controller = RetailerReportsFilterController;
    this.bindings = {
      idPrefix: '@',
      filters: '<',
      errors: '=',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/components/retailer-reports-filter/retailer-reports-filter-component.js